import { useRouter } from 'next/router'
import { getURLSearch } from 'lib/navigation/helpers/getURLSearch/getURLSearch'

interface Params {
  referred_by?: Maybe<string>
}

export const useShopifyOauthArguments = ({ referred_by }: Params) => {
  const { query } = useRouter()

  return referred_by === 'shopify' ? getURLSearch(query, { decode: true }) : null
}
